import Button from "../../material/button/Button";

const RoleRegistration = ({
  analystCheck,
  setAnalystCheck,
  approverCheck,
  setApproverCheck,
  attachFile,
  setAttachFile,
  inputFileRef,
  inputFileChange,
  formatFileSize,
}) => {
  return (
    <div className="max-w-[1000px] mx-auto mt-4">
      <div className="flex items-center gap-5">
        <div className="text-[16px] text-[#000000]">เลือกหน้าที่</div>
        <div className="text-[16px] text-[#000000]">
          (เลือกได้มากกว่า 1 ข้อ)
        </div>
        <div className="flex items-center gap-[10px]">
          <input
            id="analyst"
            checked={analystCheck}
            onChange={(e) => {
              setAnalystCheck(e.target.checked);
            }}
            type="checkbox"
          ></input>
          <div className="text-[16px] text-[#000000]">ผู้วิเคราะห์</div>
        </div>
        <div className="flex items-center gap-[10px]">
          <input
            id="approver"
            checked={approverCheck}
            onChange={(e) => {
              setApproverCheck(e.target.checked);
            }}
            type="checkbox"
          ></input>
          <div className="text-[16px] text-[#000000]">ผู้รับรองผล</div>
        </div>
      </div>

      <div className="text-[16px] text-[#000000]">คำร้องขอใช้ระบบ</div>
      <div className="text-[16px] text-[#000000]">
        สำหรับนักวิทยาศาสตร์การแพทย์
        หรือเจ้าหน้าที่ในวิชาชีพที่ไม่มีเลขใบประกอบวิชาชีพเพื่อให้ผู้ดูแลระบบในระดับห้องปฏิบัติการรับรองและอนุญาตการทำงานของเจ้าหน้าที่
      </div>
      <div className="flex items-center gap-4">
        <Button
          onClick={() => {
            inputFileRef.current.click();
          }}
        >
          <span className="text-white text-[1.5rem]">
            <svg
              width="0.78em"
              height="1em"
              viewBox="0 0 18 23"
              xmlns="http://www.w3.org/2000/svg"
            >
              {" "}
              <path
                d="M15.339 1.39258H8.53696C8.08275 0.562927 7.20949 0 6.20857 0C5.20764 0 4.33439 0.562927 3.88018 1.39258H2.66082C1.19356 1.39258 0 2.60161 0 4.08789V20.3047C0 21.791 1.19356 23 2.66082 23H15.3392C16.8063 23 18 21.791 18 20.3047V4.08789C17.9998 2.60161 16.8063 1.39258 15.339 1.39258ZM16.226 20.3047C16.226 20.8001 15.828 21.2031 15.339 21.2031H2.66082C2.17179 21.2031 1.77388 20.8001 1.77388 20.3047V4.08789C1.77388 3.59252 2.17179 3.18945 2.66082 3.18945H7.09551V9.61328C7.09551 10.1087 6.6976 10.5117 6.20857 10.5117C5.71954 10.5117 5.32163 10.1087 5.32163 9.61328V5.30078H3.54775V9.61328C3.54775 11.0996 4.74131 12.3086 6.20857 12.3086C7.67583 12.3086 8.86938 11.0996 8.86938 9.61328V3.18945H15.3392C15.8282 3.18945 16.2261 3.59252 16.2261 4.08789V20.3047H16.226ZM3.54775 17.6094H10.865V19.4062H3.54775V17.6094ZM3.54775 14.0605H14.4127V15.8574H3.54775V14.0605ZM10.5989 10.5566H14.4127V12.3535H10.5989V10.5566ZM10.5989 7.00781H14.4127V8.80469H10.5989V7.00781Z"
                fill="currentColor"
              />{" "}
            </svg>
          </span>
          <span>แนบไฟล์</span>
        </Button>
        <input
          type={"file"}
          ref={inputFileRef}
          onChange={(e) => {
            inputFileChange(e);
          }}
          style={{ display: "none" }}
        />
      </div>

      {attachFile ? (
        <div className="flex justify-between items-center bg-[#F6F6F6] p-2 border-dashed border-[#42A1EF] border-[2px]">
          <div>
            {attachFile.file_name}
            <br />
            <span>{formatFileSize(attachFile.size)}</span>
          </div>
          <button
            className="cursor-pointer"
            onClick={() => {
              setAttachFile(null);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-x"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M18 6l-12 12" />
              <path d="M6 6l12 12" />
            </svg>
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default RoleRegistration;
